import auth from '@/plugins/api/endpoints/auth';
import accounts from '@/plugins/api/endpoints/accounts';
import billing from '@/plugins/api/endpoints/billing';
import company from '@/plugins/api/endpoints/company';
import packages from '@/plugins/api/endpoints/packages';
import city from '@/plugins/api/endpoints/city';
import country from '@/plugins/api/endpoints/country';
import users from '@/plugins/api/endpoints/users';
import agencies from '@/plugins/api/endpoints/agencies';
import locations from '@/plugins/api/endpoints/locations';
import agents from '@/plugins/api/endpoints/agents';
import poBox from '@/plugins/api/endpoints/poBox';
import customers from '@/plugins/api/endpoints/customers';
import carrier from '@/plugins/api/endpoints/carrier';
import packTypes from '@/plugins/api/endpoints/packTypes';
import warehouse from '@/plugins/api/endpoints/warehouse';
import warehouseRate from '@/plugins/api/endpoints/warehouseRate';
import loadUnits from '@/plugins/api/endpoints/loadUnits';
import prepack from '@/plugins/api/endpoints/prepack';
import state from '@/plugins/api/endpoints/state';
import shipments from '@/plugins/api/endpoints/shipment';
import companySteps from '@/plugins/api/endpoints/companySteps';
import invoices from '@/plugins/api/endpoints/invoices';
import payments from '@/plugins/api/endpoints/payments';
import pickups from '@/plugins/api/endpoints/pickups';
import deliveryList from '@/plugins/api/endpoints/deliveryList';
import pickupsRoutes from '@/plugins/api/endpoints/pickupsRoutes';
import consolidated from '@/plugins/api/endpoints/consolidated';
import alerts from '@/plugins/api/endpoints/alerts';
import miscellaneous from '@/plugins/api/endpoints/miscellaneous';
import repacking from '@/plugins/api/endpoints/repacking';
import consolTypes from '@/plugins/api/endpoints/consolTypes';
import templatePacks from '@/plugins/api/endpoints/templatePacks';
import label from '@/plugins/api/endpoints/label';
import profiles from './endpoints/profile';
import zones from '@/plugins/api/endpoints/zones';
import account from './endpoints/account';
import bodyEmail from '@/plugins/api/endpoints/bodyEmail';
import regions from '@/plugins/api/endpoints/regions';
import termsAndConditions from './endpoints/termsAndConditions';
import vehicle from './endpoints/vehicle';
import branch from './endpoints/branch';
import localTransporters from './endpoints/localTransporters';
import seaPort from './endpoints/seaPort';
import paidType from './endpoints/paidType';
import stepStatus from './endpoints/stepStatus';
import status from './endpoints/status';
import config from './endpoints/config';
import shipmentRate from './endpoints/shipmentRate';
import packageTemplates from './endpoints/packageTemplates';
import emailSetup from './endpoints/emailSetup';
import externalIntegration from './endpoints/externalIntegration';
import transporter from './endpoints/transporter';
import groupTariff from './endpoints/groupTariff';
import consolidatedType from './endpoints/consolidatedType';
import services from './endpoints/services';
import labelFormat from './endpoints/labelFormat';
import quickbooks from './endpoints/quickbooks';
import jasperServer from './endpoints/jasperServer';
import whatsappTemplates from '@/plugins/api/endpoints/whatsappTemplates';
import whatsappContentTemplates from '@/plugins/api/endpoints/whatsappContentTemplates';
import documents from '@/plugins/api/endpoints/documents';
import correlative from '@/plugins/api/endpoints/correlative';
import consolcheck from '@/plugins/api/endpoints/consolcheck';

export default {
    install: install,
    backendApi
};

function install(app) {
    app.config.globalProperties.backendApi = backendApi;
}

function backendApi() {
    return {
        auth,
        accounts,
        billing,
        company,
        packages,
        users,
        agencies,
        agents,
        poBox,
        locations,
        customers,
        carrier,
        packTypes,
        city,
        country,
        warehouse,
        warehouseRate,
        loadUnits,
        prepack,
        state,
        shipments,
        companySteps,
        invoices,
        payments,
        pickups,
        deliveryList,
        pickupsRoutes,
        consolidated,
        alerts,
        miscellaneous,
        repacking,
        consolTypes,
        templatePacks,
        label,
        profiles,
        zones,
        account,
        bodyEmail,
        regions,
        termsAndConditions,
        vehicle,
        branch,
        localTransporters,
        seaPort,
        paidType,
        stepStatus,
        config,
        shipmentRate,
        packageTemplates,
        emailSetup,
        transporter,
        groupTariff,
        consolidatedType,
        services,
        status,
        labelFormat,
        quickbooks,
        jasperServer,
        whatsappTemplates,
        whatsappContentTemplates,
        documents,
        correlative,
        externalIntegration,
        consolcheck
    };
}
